import { ArrowForwardIos, HomeOutlined } from "@mui/icons-material";
import React from "react";
import CustomText from "components/typography/CustomText";
import { formatArray } from "lib/arrayObject";
import CustomLink from "components/CustomLink";

export default function BreadCrumb({ data = [] }) {
  const pathname = window.location.pathname;
  return (
    <div className="h-full pr-2 flex items-center border-r border-white-gray">
      <HomeOutlined
        className={`${
          pathname === "/bake-dates" || pathname === "/weekly-slots"
            ? "text-white"
            : "text-dark-blue"
        } mr-2`}
      />
      {formatArray(data).map((item, itemIndex) => {
        return (
          <div key={itemIndex} className="flex items-center">
            <ArrowForwardIos
              fontSize="small"
              className={`${
                pathname === "/bake-dates" || pathname === "/weekly-slots"
                  ? "text-white"
                  : "text-dark-blue"
              } mr-2`}
            />
            <CustomLink to={item?.to ?? "#"}>
              <CustomText
                bold={600}
                color={
                  pathname === "/bake-dates" || pathname === "/weekly-slots"
                    ? "white"
                    : "secondary"
                }
                className={`mr-2`}
              >
                {item?.label ?? ""}
              </CustomText>
            </CustomLink>
          </div>
        );
      })}
    </div>
  );
}
